/**
 * @generated SignedSource<<9a48a79509be0ff724d656fd2cfa7d97>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueBodyHeaderSecondaryFragment_issue$data = {
  readonly repository: {
    readonly isPrivate: boolean;
    readonly name: string;
    readonly owner: {
      readonly login: string;
    };
  };
  readonly viaApp: {
    readonly logoBackgroundColor: string;
    readonly logoUrl: string;
    readonly name: string;
    readonly url: string;
  } | null | undefined;
  readonly " $fragmentType": "IssueBodyHeaderSecondaryFragment_issue";
};
export type IssueBodyHeaderSecondaryFragment_issue$key = {
  readonly " $data"?: IssueBodyHeaderSecondaryFragment_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBodyHeaderSecondaryFragment_issue">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueBodyHeaderSecondaryFragment_issue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrivate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "login",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "App",
      "kind": "LinkedField",
      "name": "viaApp",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "size",
              "value": 40
            }
          ],
          "kind": "ScalarField",
          "name": "logoUrl",
          "storageKey": "logoUrl(size:40)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logoBackgroundColor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "8f9391dda77ea98ab9c9c53fb7992f1a";

export default node;
